import taxesActions from 'store/actions/taxes'
import paymentConditionActions from 'store/actions/payment_conditions'
import clientPaymentConditionActions from 'store/actions/client_payment_conditions'
import moduleGroupRelActions from 'store/actions/module_group_rel'
import moduleWizardRelActions from 'store/actions/module_wizard_rel'
import sysModuleActions from 'store/actions/sys_modules'
import equipmentOwnersActions from 'store/actions/equipment_owners'
import clientActions from 'store/actions/clients'
import companyActions from 'store/actions/companys'
import locationActions from 'store/actions/locations'
import clientGroupActions from 'store/actions/client_groups'
import branchOfficeActions from 'store/actions/branch_office'
import bankTypeActions from 'store/actions/bank_type'
import typeOfIDActions from 'store/actions/type_of_id'
import statesActions from 'store/actions/states'
import bankKeyElectronicPaymentActions from 'store/actions/bank_key_electronic_payment'
import deliveryRouteZoneActions from 'store/actions/delivery_route_zones'
import clientWorkShiftActions from 'store/actions/client_work_shifts'
import clientRouteActions from 'store/actions/client_routes'
import clientBranchesActions from 'store/actions/client_branches'
import unitActions from 'store/actions/units'
import trailerActions from 'store/actions/trailers'
import cfdiActions from 'store/actions/cfdi'
import pendingFileActions from 'store/actions/pending_file'
import employeeActions from 'store/actions/employees'
import departmentActions from 'store/actions/departments'
import jobTitleActions from 'store/actions/job_titles'
import workShiftActions from 'store/actions/work_shifts'
import userActions from 'store/actions/users'
import roleActions from 'store/actions/roles'
import stationActions from 'store/actions/stations'
import documentActions from 'store/actions/documents'
import employeeWorkShiftActions from 'store/actions/employee_work_shifts'
import unitAxleTemplateActions from 'store/actions/unit_axle_templates'
import unitGroupActions from 'store/actions/unit_groups'
import unitAdditionalFieldActions from 'store/actions/unit_additional_fields'
import supplierActions from 'store/actions/suppliers'
import unitTypeRateActions from 'store/actions/unit_type_rates'
import travelsActions from 'store/actions/travels'
import requestsActions from 'store/actions/requests'
import merchandiseTypeActions from 'store/actions/merchandise_types'
import distribution_centerActions from 'store/actions/distribution_centers'
import trailerGroupActions from 'store/actions/trailer_groups'
import trailerAxleTemplateActions from 'store/actions/trailer_axle_templates'
import unitMeasureActions from 'store/actions/unit_measures'
import customCatalogActions from 'store/actions/custom_catalog'
import servicesActions from 'store/actions/services'
import routeSetupActions from 'store/actions/route_setups'
import starmilkRouteActions from 'store/actions/starmilk_routes'
import origin_destinationActions from 'store/actions/origins_destinations'
import folioActions from 'store/actions/folios'
import tollActions from 'store/actions/tolls'
import transport_meansActions from 'store/actions/transport_means'
import transport_figureActions from 'store/actions/transport_figures'
import banksActions from 'store/actions/banks'
import bankTransactionActions from 'store/actions/bank_transactions'
import bankCatalogActions from 'store/actions/bank_catalog'
import tourActions from 'store/actions/tours'
import inspectionFormatActions from 'store/actions/inspection_formats'
import inspectionCategoryActions from 'store/actions/inspection_category'
import incidentActions from 'store/actions/incidents'
import hr_categoryActions from 'store/actions/hr_category'
import associatesActions from 'store/actions/associates'

const EQUIPMENT_OWNER_FIELDS = ['Units.fields(id)', 'Trailers.fields(id)']
const UNIT_FIELDS = ['id', 'sys_company_id', 'name', 'equipment_owner_id']
const CLIENT_LIST_FIELDS = [
    'Company.fields()',
    'TaxData.fields()',
    'ClientGroup.fields()',
]
const CLIENT_DETAIL_FIELDS = [
    'Company.fields()',
    'TaxData.fields()',
    'ClientGroup.fields()',
    'Locations.fields()',
    'ClientContacts.fields()',
    'User.fields()',
    'ElectronicPayments.fields()',
    'ClientBusinessDays.fields()',
    'ClientTaxes.fields()',
    'CfdiBankAccounts.fields()',
]
const SAT_CATALOG_NAMES = [
    'c_CodigoPostal',
    'c_Pais',
    'c_Estado',
    'c_Municipio',
    'c_Localidad',
    'c_Colonia_1',
    'c_Colonia_2',
    'c_Colonia_3',
]
const CLIENT_SAT_CATALOG_NAMES = [
    'c_RegimenFiscal',
    'c_UsoCFDI',
    'c_FormaPago',
    'c_MetodoPago',
    'c_Pais',
    'c_Estado',
    'c_Municipio',
    'c_Localidad',
    'c_Banco',
]
const PENDING_FILE_FIELDS = {
    CLIENT: ['Client.fields()'],
    SUPPLIER: ['Supplier.fields()'],
}
const EMPLOYEE_LIST_FIELDS = [
    'JobTitle.fields()',
    'Department.fields()',
    'Company.fields()',
    'EmployeeWorkShift.fields()',
    'BranchOffice.fields()',
]
const EMPLOYEE_DETAIL_FIELDS = [
    'TaxData.fields()',
    'Department.fields()',
    'Station.fields()',
    'Assets.fields()',
    'DriversPermits.fields()',
    'Accounts.fields()',
    'Contacts.fields()',
]
const CLIENT_BRANCH_DETAIL_FIELDS = ['Coordinator.fields()', 'Client.fields()']
const CLIENT_ROUTE_SUPPORT_FIELDS = [
    'DefaultEmployee.fields()',
    'DefaultUnit.fields()',
]
const UNITS_LIST_FIELDS = [
    'AxleTemplate.fields()',
    'UnitGroup.fields()',
    'UnitAdditionalFieldsValues.fields()',
    'DefaultClient.fields()',
]
const UNITS_LIST_FIELDS_WITH_TIRES = [
    ...UNITS_LIST_FIELDS,
    'FirstTrailer.fields()',
    'SecondTrailer.fields()',
]
const UNIT_DETAIL_FIELDS = [
    'Employee.fields()',
    'Route.fields()',
    'AxleTemplate.fields()',
    'FirstTrailer.fields()',
    'SecondTrailer.fields()',
    'DocumentItems.fields()',
    'SecuritySeal.fields()',
    'Assets.fields()',
    'InspectionFormat.fields()',
]
const TRAILER_LIST_FIELDS = [
    'AxleTemplate.fields()',
    'Company.fields()',
    'TrailerGroup.fields()',
    'BranchOffice.fields()',
]

const createMatcher = (regex, parser = (match) => match.groups || {}) => (path) => {
    const match = path.match(regex)
    if (!match) return null
    return parser(match)
}

const resolvePaymentActions = (scope) => {
    return scope === 'suppliers'
        ? {
            load: paymentConditionActions.load,
            get: paymentConditionActions.get,
        }
        : {
            load: clientPaymentConditionActions.load,
            get: clientPaymentConditionActions.get,
        }
}

const warmEquipmentOwnersList = async ({ dispatch }) => {
    await Promise.all([
        dispatch(equipmentOwnersActions.load({
            force: true,
            params: {
                fields: EQUIPMENT_OWNER_FIELDS,
            },
        })),
        dispatch(unitActions.load({
            force: true,
            params: {
                fields: UNIT_FIELDS,
            },
        })),
        dispatch(trailerActions.load({
            force: true,
            params: {
                fields: UNIT_FIELDS,
            },
        })),
    ])

    return { warmed: true }
}

const warmEquipmentOwnerCatalogs = async ({ dispatch }) => {
    const satCatalogs = await dispatch(cfdiActions.loadSatCatalogs(SAT_CATALOG_NAMES))
    return { satCatalogs }
}

const hasWialonRights = (state) => {
    const user = state.app.user
    return !!(
        user?.use_wialon_connection &&
        user?.modules?.some((module) => module.url === 'wialon_connection')
    )
}

const canLoadClientStaffData = (state) => {
    const moduleIds = state.app.user?.modules?.map((module) => module.id) || []
    return moduleIds.includes(7) && moduleIds.includes(8)
}

const hasDocumentsRights = (state) => {
    return state.app.user?.modules?.some((module) => module.url === 'documents')
}

const hasStationsRights = (state) => {
    return state.app.user?.modules?.some((module) => module.url === 'stations')
}

const hasCompaniesRights = (state) => {
    return state.app.user?.modules?.some((module) => module.url === 'companies')
}

const hasTireAssignationRights = (state) => {
    return state.app.user?.modules?.some((module) => module.url === 'tire_assignation')
}

const warmClientsList = async ({ dispatch, getState }) => {
    const tasks = [
        dispatch(clientActions.load({
            page: 1,
            limit: 50,
            params: {
                fields: CLIENT_LIST_FIELDS,
            },
            force: true,
        })),
        dispatch(clientGroupActions.list({ force: true })),
        dispatch(branchOfficeActions.load({ params: {} })),
    ]

    if (hasWialonRights(getState())) {
        tasks.push(dispatch(locationActions.loadWialonGeofences()))
    }

    await Promise.all(tasks)
    return { warmed: true }
}

const warmClientsSupportData = async ({ dispatch, getState }) => {
    const tasks = [
        dispatch(companyActions.list()),
        dispatch(locationActions.list({
            params: {
                fields: ['TaxData.fields()'],
            },
            force: true,
        })),
        dispatch(clientGroupActions.list({ force: true })),
        dispatch(branchOfficeActions.load({})),
        dispatch(bankTypeActions.load({ force: true })),
        dispatch(typeOfIDActions.load({ force: true })),
        dispatch(statesActions.load({ force: true })),
        dispatch(deliveryRouteZoneActions.load({})),
        dispatch(bankKeyElectronicPaymentActions.load({})),
        dispatch(clientActions.getTimeZonesList()),
        dispatch(cfdiActions.loadSatCatalogs(CLIENT_SAT_CATALOG_NAMES)),
    ]

    if (hasWialonRights(getState())) {
        tasks.push(dispatch(locationActions.loadWialonGeofences()))
    }

    if (canLoadClientStaffData(getState())) {
        tasks.push(
            dispatch(clientWorkShiftActions.load({
                params: {
                    fields: 'ClientBranch.fields()',
                },
            })),
            dispatch(clientRouteActions.load({})),
            dispatch(clientBranchesActions.load({
                params: {
                    fields: ['Coordinator.fields()'],
                },
            }))
        )
    }

    await Promise.all(tasks)
    return { warmed: true }
}

const warmPendingFiles = async ({ dispatch, userType }) => {
    const items = await dispatch(pendingFileActions.load({
        force: true,
        params: {
            user_type: userType,
            fields: PENDING_FILE_FIELDS[userType],
        },
    }))

    return {
        items: Array.isArray(items) ? items : [],
        userType,
    }
}

const warmEmployeesList = async ({ dispatch, getState }) => {
    const canLoadWialon = hasWialonRights(getState())
    const tasks = [
        dispatch(employeeActions.load({
            page: 1,
            limit: 50,
            params: {
                fields: EMPLOYEE_LIST_FIELDS,
            },
            force: true,
        })),
        dispatch(departmentActions.load({ force: true })),
        dispatch(jobTitleActions.load({
            params: {
                fields: 'WorkShift.fields()',
            },
            force: true,
        })),
        dispatch(branchOfficeActions.load()),
    ]

    if (canLoadWialon) {
        tasks.push(dispatch(employeeActions.loadWialonDrivers()))
    }

    const [items] = await Promise.all(tasks)

    return {
        items: Array.isArray(items) ? items : [],
        supportLoaded: true,
        wialonDriversLoaded: canLoadWialon,
    }
}

const warmEmployeeSupportData = async ({ dispatch, getState, includeAuthData = false }) => {
    const canLoadWialon = hasWialonRights(getState())
    const canLoadDocuments = hasDocumentsRights(getState())
    const canLoadStationsData = hasStationsRights(getState())
    const canLoadCompaniesData = hasCompaniesRights(getState())
    const tasks = [
        dispatch(jobTitleActions.load({
            params: {
                fields: 'WorkShift.fields()',
            },
            force: true,
        })),
        dispatch(departmentActions.load({ force: true })),
        dispatch(sysModuleActions.load({ force: true })),
        dispatch(unitActions.load({
            params: {},
            force: true,
        })),
        dispatch(employeeWorkShiftActions.load({
            params: {},
            force: true,
        })),
        dispatch(branchOfficeActions.load()),
    ]

    if (includeAuthData) {
        tasks.push(
            dispatch(userActions.load({
                params: {
                    fields: 'Role.fields()',
                },
            })),
            dispatch(roleActions.load())
        )
    }

    if (canLoadDocuments) {
        tasks.push(dispatch(documentActions.load({
            params: {
                type: 'EMPLEADO',
            },
            force: true,
        })))
    }

    if (canLoadStationsData) {
        tasks.push(dispatch(stationActions.load()))
    }

    if (canLoadCompaniesData) {
        tasks.push(dispatch(companyActions.load()))
    }

    if (canLoadWialon) {
        tasks.push(
            dispatch(employeeActions.loadWialonDrivers()),
            dispatch(locationActions.loadWialonGeofences())
        )
    }

    await Promise.all(tasks)

    return {
        supportLoaded: true,
        authDataLoaded: includeAuthData,
        documentsLoaded: canLoadDocuments,
        stationsLoaded: canLoadStationsData,
        companiesLoaded: canLoadCompaniesData,
        wialonDriversLoaded: canLoadWialon,
        geofencesLoaded: canLoadWialon,
    }
}

const warmEmployeeWorkShiftsList = async ({ dispatch }) => {
    const items = await dispatch(employeeWorkShiftActions.load({
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmDepartmentsList = async ({ dispatch }) => {
    const items = await dispatch(departmentActions.load({
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmJobTitlesList = async ({ dispatch }) => {
    const items = await dispatch(jobTitleActions.load({
        params: {
            fields: 'WorkShift.fields()',
        },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmJobTitlesSupportData = async ({ dispatch }) => {
    await dispatch(workShiftActions.load())

    return {
        supportLoaded: true,
    }
}

const warmUnitAxleTemplatesList = async ({ dispatch }) => {
    const items = await dispatch(unitAxleTemplateActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmStatesList = async ({ dispatch }) => {
    const items = await dispatch(statesActions.load({
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmMerchandiseTypesList = async ({ dispatch }) => {
    const items = await dispatch(merchandiseTypeActions.load({
        page: 1,
        limit: 50,
        params: { fields: ['name'] },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmDistributionCentersList = async ({ dispatch }) => {
    const items = await dispatch(distribution_centerActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmDeliveryRouteZonesList = async ({ dispatch }) => {
    const items = await dispatch(deliveryRouteZoneActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmLocationsList = async ({ dispatch }) => {
    const items = await dispatch(locationActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmServicesList = async ({ dispatch }) => {
    const items = await dispatch(servicesActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmDriverExpensesList = async ({ dispatch }) => {
    const items = await dispatch(routeSetupActions.load({
        page: 1,
        limit: 50,
        params: {
            fields: [
                'User.fields()',
                'Route.fields()',
                'AlternateLocation.fields()',
                'FirstTrailer.fields()',
                'Unit.fields()',
            ],
        },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmStarmilkRoutesList = async ({ dispatch }) => {
    const items = await dispatch(starmilkRouteActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmOriginsDestinationsList = async ({ dispatch }) => {
    const items = await dispatch(origin_destinationActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmFoliosList = async ({ dispatch }) => {
    const items = await dispatch(folioActions.load({
        page: 1,
        limit: 50,
        params: { fields: ['Company.fields()'] },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmTollsList = async ({ dispatch }) => {
    const items = await dispatch(tollActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmCompaniesList = async ({ dispatch }) => {
    const items = await dispatch(companyActions.load({
        page: 1,
        limit: 50,
        params: { fields: 'Clients.fields()' },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmTransportMeansList = async ({ dispatch }) => {
    const items = await dispatch(transport_meansActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmTransportFiguresList = async ({ dispatch }) => {
    const items = await dispatch(transport_figureActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmWorkShiftsList = async ({ dispatch }) => {
    const items = await dispatch(workShiftActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmRolesList = async ({ dispatch }) => {
    const items = await dispatch(roleActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmUsersList = async ({ dispatch }) => {
    const items = await dispatch(userActions.load({
        page: 1,
        limit: 50,
        params: {
            fields: [
                'Role.fields()',
                'Station.fields()',
                'BranchOffice.fields()',
                'Company.fields()',
                'Department.fields()',
                'JobTitle.fields()',
                'UserPermits.fields()',
            ],
        },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmBranchOfficesList = async ({ dispatch }) => {
    const items = await dispatch(branchOfficeActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmBanksList = async ({ dispatch }) => {
    const items = await dispatch(banksActions.load({
        page: 1,
        limit: 50,
        params: { fields: ['TaxData.fields()'] },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmBankTransactionsList = async ({ dispatch }) => {
    const items = await dispatch(bankTransactionActions.load({
        page: 1,
        limit: 50,
        params: { fields: ['Expense.fields()', 'Company.fields()'] },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmBankCatalogList = async ({ dispatch }) => {
    const items = await dispatch(bankCatalogActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmToursList = async ({ dispatch }) => {
    const items = await dispatch(tourActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmIncidentsList = async ({ dispatch }) => {
    const items = await dispatch(incidentActions.load({
        page: 1,
        limit: 50,
        params: { fields: ['Incident_Category.fields()'] },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmHRCategoriesList = async ({ dispatch }) => {
    const items = await dispatch(hr_categoryActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmAssociatesList = async ({ dispatch }) => {
    const items = await dispatch(associatesActions.load({
        page: 1,
        limit: 50,
        params: { fields: ['SysCompanies.fields(id)'] },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmInspectionFormatsList = async ({ dispatch }) => {
    const items = await dispatch(inspectionFormatActions.load({
        page: 1,
        limit: 50,
        params: { fields: ['InspectionCategory.fields()'] },
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmInspectionCategorysList = async ({ dispatch }) => {
    const items = await dispatch(inspectionCategoryActions.loadCategories({
        page: 1,
        limit: 50,
        force: true,
    }))

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
    }
}

const warmUnitsList = async ({ dispatch, getState }) => {
    const canLoadTireData = hasTireAssignationRights(getState())
    const unitFields = canLoadTireData ? UNITS_LIST_FIELDS_WITH_TIRES : UNITS_LIST_FIELDS

    const tasks = [
        dispatch(unitActions.load({
            page: 1,
            limit: 50,
            params: {
                fields: unitFields,
            },
            force: true,
        })),
        dispatch(userActions.load()),
        dispatch(branchOfficeActions.load({
            params: {},
        })),
        dispatch(unitGroupActions.load({
            force: true,
        })),
        dispatch(unitActions.loadAllUnits()),
        dispatch(unitAdditionalFieldActions.loadUnitAdditionalFields()),
        dispatch(unitActions.getCurrentOdometerUnits()),
    ]

    if (canLoadTireData) {
        tasks.push(
            dispatch(unitAxleTemplateActions.load()),
            dispatch(trailerActions.load()),
            dispatch(unitActions.loadWialonUnits())
        )
    }

    const [items, , , , allUnits, unitAdditionalFields] = await Promise.all(tasks)

    return {
        items: Array.isArray(items) ? items : [],
        listLoaded: true,
        tireSupportLoaded: canLoadTireData,
        odometersLoaded: true,
        allUnits: Array.isArray(allUnits) ? allUnits : [],
        unitAdditionalFields: Array.isArray(unitAdditionalFields) ? unitAdditionalFields : [],
    }
}

const warmUnitsSupportData = async ({ dispatch, itemId = null }) => {
    const [
        ,
        ,
        ,
        ,
        ,
        typesCatalog,
        unitAdditionalFields,
        unitTypes,
        permisitionsList,
        loadedUnit,
    ] = await Promise.all([
        dispatch(employeeActions.load({
            params: {
                fields: 'JobTitle.fields()',
            },
        })),
        dispatch(branchOfficeActions.load({
            params: {},
        })),
        dispatch(clientActions.load({
            params: {},
        })),
        dispatch(supplierActions.load({
            force: true,
        })),
        dispatch(equipmentOwnersActions.load({
            force: true,
        })),
        dispatch(unitActions.getTypesCatalog()),
        dispatch(unitAdditionalFieldActions.loadUnitAdditionalFields()),
        dispatch(unitTypeRateActions.getUnitTypes()),
        dispatch(travelsActions.getSysModuleUserPermisitions()),
        itemId
            ? dispatch(unitActions.get(itemId, {
                params: {
                    fields: UNIT_DETAIL_FIELDS,
                },
            }))
            : Promise.resolve(null),
    ])

    const mappedUnitTypeOptions = Array.isArray(unitTypes)
        ? unitTypes.map((unitType) => ({
            key: unitType.key,
            value: unitType.key,
            label: unitType.name,
            text: unitType.name,
        }))
        : []
    const item = itemId && loadedUnit?.id === itemId
        ? loadedUnit
        : null

    return {
        supportLoaded: true,
        unitEntitiesLoaded: !!itemId,
        typesCatalog: Array.isArray(typesCatalog) ? typesCatalog : [],
        unitAdditionalFields: Array.isArray(unitAdditionalFields) ? unitAdditionalFields : [],
        unitTypes: Array.isArray(unitTypes) ? unitTypes : [],
        unitTypeOptions: mappedUnitTypeOptions,
        permisitionsList: Array.isArray(permisitionsList) ? permisitionsList : [],
        item,
    }
}

const warmClientBranchesSupportData = async ({ dispatch, itemId = null }) => {
    const [clients, employees, clientRoutes, clientWorkShifts, item] = await Promise.all([
        dispatch(clientActions.load()),
        dispatch(employeeActions.load()),
        dispatch(clientRouteActions.load({
            params: {
                fields: CLIENT_ROUTE_SUPPORT_FIELDS,
            },
        })),
        dispatch(clientWorkShiftActions.load()),
        itemId
            ? dispatch(clientBranchesActions.get(itemId, {
                params: {
                    fields: CLIENT_BRANCH_DETAIL_FIELDS,
                },
            }))
            : Promise.resolve(null),
    ])

    return {
        supportLoaded: true,
        clientsLoaded: Array.isArray(clients),
        employeesLoaded: Array.isArray(employees),
        clientRoutesLoaded: Array.isArray(clientRoutes),
        clientWorkShiftsLoaded: Array.isArray(clientWorkShifts),
        item,
    }
}

const warmTrailersList = async ({ dispatch, getState }) => {
    await Promise.all([
        dispatch(trailerActions.load({
            page: 1,
            limit: 50,
            params: { fields: TRAILER_LIST_FIELDS },
            force: true,
        })),
        dispatch(trailerGroupActions.load({ force: true })),
        dispatch(branchOfficeActions.load({ params: {} })),
        dispatch(trailerAxleTemplateActions.load()),
        dispatch(unitActions.loadWialonUnits()),
    ])
    return { warmed: true }
}

const warmUnitMeasuresList = async ({ dispatch }) => {
    await dispatch(unitMeasureActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))
    return { warmed: true }
}

const SUPPLIER_LIST_FIELDS = [
    'Company.fields()',
    'TaxData.fields()',
    'PaymentCondition.fields()',
    'PaymentCondition2.fields()',
    'BranchOffice.fields()',
    'SupplierGroup.fields()',
]

const warmSuppliersList = async ({ dispatch }) => {
    await dispatch(supplierActions.load({
        page: 1,
        limit: 50,
        params: { fields: SUPPLIER_LIST_FIELDS },
        force: true,
    }))
    return { warmed: true }
}

const warmCustomCatalogsList = async ({ dispatch }) => {
    await dispatch(customCatalogActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))
    return { warmed: true }
}

const warmTrailerAxleTemplatesList = async ({ dispatch }) => {
    await dispatch(trailerAxleTemplateActions.load({
        page: 1,
        limit: 50,
        force: true,
    }))
    return { warmed: true }
}

export const catalogosWarmHandlers = [
    {
        id: 'catalogos.taxes.list',
        ttlMs: 60000,
        match: createMatcher(/^\/taxes$/),
            prefetch: async ({ dispatch }) => {
                await dispatch(taxesActions.load({
                    page: 1,
                    limit: 50,
                    force: true,
                }))
                return { warmed: true }
            },
    },
    {
        id: 'catalogos.taxes.new',
        ttlMs: 30000,
        match: createMatcher(/^\/taxes\/new$/),
        prefetch: async () => ({ warmed: true }),
    },
    {
        id: 'catalogos.taxes.detail',
        ttlMs: 45000,
        match: createMatcher(/^\/taxes\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const item = await dispatch(taxesActions.getTaxesById(params.id))
            return { item }
        },
    },
    {
        id: 'catalogos.payment_condition.list',
        ttlMs: 300000,
        match: createMatcher(/^\/payment_condition\/(?<scope>clients|suppliers)$/, (match) => ({
            scope: match.groups.scope,
        })),
        prefetch: async ({ dispatch, params }) => {
            const actions = resolvePaymentActions(params.scope)
            await dispatch(actions.load({ page: 1, limit: 50, force: true }))
            return { scope: params.scope }
        },
    },
    {
        id: 'catalogos.payment_condition.new',
        ttlMs: 30000,
        match: createMatcher(/^\/payment_condition\/(?<scope>clients|suppliers)\/new$/, (match) => ({
            scope: match.groups.scope,
        })),
        prefetch: async ({ params }) => ({ scope: params.scope }),
    },
    {
        id: 'catalogos.payment_condition.detail',
        ttlMs: 45000,
        match: createMatcher(/^\/payment_condition\/(?<scope>clients|suppliers)\/(?<id>\d+)$/, (match) => ({
            scope: match.groups.scope,
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const actions = resolvePaymentActions(params.scope)
            const item = await dispatch(actions.get(params.id))
            return { item, scope: params.scope }
        },
    },
    {
        id: 'catalogos.wizard.list',
        ttlMs: 60000,
        match: createMatcher(/^\/wizard$/),
        prefetch: async ({ dispatch }) => {
            await dispatch(moduleGroupRelActions.load({
                page: 1,
                limit: 50,
                force: true,
            }))
            return { warmed: true }
        },
    },
    {
        id: 'catalogos.wizard.detail',
        ttlMs: 45000,
        match: createMatcher(/^\/wizard\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const [wizardRelations, moduleGroup] = await Promise.all([
                dispatch(moduleWizardRelActions.getModuleWizardRel(params.id)),
                dispatch(moduleGroupRelActions.getModuleGroup(params.id)),
                dispatch(sysModuleActions.load()),
            ])

            return {
                wizardRelations,
                moduleGroup,
                modulesLoaded: true,
            }
        },
    },
    {
        id: 'catalogos.equipment_owners.list',
        ttlMs: 45000,
        match: createMatcher(/^\/equipment_owners\/(?<scope>units|trailers)$/, (match) => ({
            scope: match.groups.scope,
        })),
        prefetch: async ({ dispatch, params }) => {
            await warmEquipmentOwnersList({ dispatch })
            return { scope: params.scope }
        },
    },
    {
        id: 'catalogos.equipment_owners.new',
        ttlMs: 30000,
        match: createMatcher(/^\/equipment_owners\/(?<scope>units|trailers)\/new$/, (match) => ({
            scope: match.groups.scope,
        })),
        prefetch: async ({ dispatch, params }) => {
            const [{ satCatalogs }, nextCode] = await Promise.all([
                warmEquipmentOwnerCatalogs({ dispatch }),
                dispatch(equipmentOwnersActions.getNextEquipmentOwnerCode()),
            ])

            return {
                scope: params.scope,
                satCatalogs,
                nextCode,
            }
        },
    },
    {
        id: 'catalogos.equipment_owners.detail',
        ttlMs: 45000,
        match: createMatcher(/^\/equipment_owners\/(?<scope>units|trailers)\/(?<id>\d+)$/, (match) => ({
            scope: match.groups.scope,
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const [{ satCatalogs }, item] = await Promise.all([
                warmEquipmentOwnerCatalogs({ dispatch }),
                dispatch(equipmentOwnersActions.get(params.id)),
            ])

            return {
                scope: params.scope,
                satCatalogs,
                item,
            }
        },
    },
    {
        id: 'catalogos.unit_sensors.list',
        ttlMs: 45000,
        match: createMatcher(/^\/unit_sensors$/),
        prefetch: async ({ dispatch }) => {
            await dispatch(unitActions.load({ force: true }))
            return { warmed: true }
        },
    },
    {
        id: 'catalogos.clients.list',
        ttlMs: 45000,
        match: createMatcher(/^\/clients\/catalogs$/),
        prefetch: warmClientsList,
    },
    {
        id: 'catalogos.clients.new',
        ttlMs: 30000,
        match: createMatcher(/^\/clients\/catalogs\/new$/),
        prefetch: async ({ dispatch, getState }) => {
            await warmClientsSupportData({ dispatch, getState })
            return { warmed: true }
        },
    },
    {
        id: 'catalogos.clients.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/clients\/catalogs\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, getState, params }) => {
            const [item] = await Promise.all([
                dispatch(clientActions.get(params.id, {
                    params: {
                        fields: CLIENT_DETAIL_FIELDS,
                    },
                })),
                warmClientsSupportData({ dispatch, getState }),
            ])

            return { item }
        },
    },
    {
        id: 'catalogos.client_file_approval.list',
        ttlMs: 30000,
        match: createMatcher(/^\/client_file_approval$/),
        prefetch: async ({ dispatch }) => warmPendingFiles({ dispatch, userType: 'CLIENT' }),
    },
    {
        id: 'catalogos.supplier_file_approval.list',
        ttlMs: 30000,
        match: createMatcher(/^\/supplier_file_approval$/),
        prefetch: async ({ dispatch }) => warmPendingFiles({ dispatch, userType: 'SUPPLIER' }),
    },
    {
        id: 'catalogos.employees.list',
        ttlMs: 300000,
        match: createMatcher(/^\/employees\/(?<scope>employees|drivers)$/, (match) => ({
            scope: match.groups.scope,
        })),
        prefetch: async ({ dispatch, getState, params }) => {
            const payload = await warmEmployeesList({ dispatch, getState })
            return {
                ...payload,
                scope: params.scope,
            }
        },
    },
    {
        id: 'catalogos.employees.new',
        ttlMs: 30000,
        match: createMatcher(/^\/employees\/(?<scope>employees|drivers)\/new$/, (match) => ({
            scope: match.groups.scope,
        })),
        prefetch: async ({ dispatch, getState, params }) => {
            const payload = await warmEmployeeSupportData({ dispatch, getState })
            return {
                ...payload,
                scope: params.scope,
                isNewItem: true,
            }
        },
    },
    {
        id: 'catalogos.employees.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/employees\/(?<scope>employees|drivers)\/(?<id>\d+)$/, (match) => ({
            scope: match.groups.scope,
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, getState, params }) => {
            const [supportPayload, item] = await Promise.all([
                warmEmployeeSupportData({ dispatch, getState, includeAuthData: true }),
                dispatch(employeeActions.get(params.id, {
                    params: {
                        fields: EMPLOYEE_DETAIL_FIELDS,
                    },
                    force: true,
                })),
            ])

            return {
                ...supportPayload,
                scope: params.scope,
                item,
            }
        },
    },
    {
        id: 'catalogos.employee_work_shifts.list',
        ttlMs: 45000,
        match: createMatcher(/^\/employee_work_shifts$/),
        prefetch: warmEmployeeWorkShiftsList,
    },
    {
        id: 'catalogos.employee_work_shifts.new',
        ttlMs: 45000,
        match: createMatcher(/^\/employee_work_shifts\/new$/),
        prefetch: async () => ({ supportLoaded: true }),
    },
    {
        id: 'catalogos.employee_work_shifts.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/employee_work_shifts\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const item = await dispatch(employeeWorkShiftActions.get(params.id))

            return {
                item,
            }
        },
    },
    {
        id: 'catalogos.departments.list',
        ttlMs: 45000,
        match: createMatcher(/^\/departments$/),
        prefetch: warmDepartmentsList,
    },
    {
        id: 'catalogos.departments.new',
        ttlMs: 45000,
        match: createMatcher(/^\/departments\/new$/),
        prefetch: async () => ({ supportLoaded: true }),
    },
    {
        id: 'catalogos.departments.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/departments\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const item = await dispatch(departmentActions.get(params.id))

            return {
                item,
            }
        },
    },
    {
        id: 'catalogos.job_titles.list',
        ttlMs: 45000,
        match: createMatcher(/^\/job_titles$/),
        prefetch: warmJobTitlesList,
    },
    {
        id: 'catalogos.job_titles.new',
        ttlMs: 45000,
        match: createMatcher(/^\/job_titles\/new$/),
        prefetch: warmJobTitlesSupportData,
    },
    {
        id: 'catalogos.job_titles.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/job_titles\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const [item] = await Promise.all([
                dispatch(jobTitleActions.get(params.id, {
                    params: {
                        fields: 'WorkShift.fields()',
                    },
                })),
                warmJobTitlesSupportData({ dispatch }),
            ])

            return {
                item,
                supportLoaded: true,
            }
        },
    },
    {
        id: 'catalogos.unit_axle_templates.list',
        ttlMs: 45000,
        match: createMatcher(/^\/unit_axle_templates$/),
        prefetch: warmUnitAxleTemplatesList,
    },
    {
        id: 'catalogos.unit_axle_templates.new',
        ttlMs: 45000,
        match: createMatcher(/^\/unit_axle_templates\/new$/),
        prefetch: async () => ({ supportLoaded: true }),
    },
    {
        id: 'catalogos.unit_axle_templates.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/unit_axle_templates\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const item = await dispatch(unitAxleTemplateActions.get(params.id))

            return {
                item,
            }
        },
    },
    {
        id: 'catalogos.states.list',
        ttlMs: 45000,
        match: createMatcher(/^\/states$/),
        prefetch: warmStatesList,
    },
    {
        id: 'catalogos.states.new',
        ttlMs: 45000,
        match: createMatcher(/^\/states\/new$/),
        prefetch: async () => ({ supportLoaded: true }),
    },
    {
        id: 'catalogos.states.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/states\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const item = await dispatch(statesActions.get(params.id))

            return {
                item,
            }
        },
    },
    {
        id: 'catalogos.merchandise_types.list',
        ttlMs: 45000,
        match: createMatcher(/^\/merchandise_types\/(freight_transport|buy)$/),
        prefetch: warmMerchandiseTypesList,
    },
    {
        id: 'catalogos.distribution_centers.list',
        ttlMs: 45000,
        match: createMatcher(/^\/distribution_centers$/),
        prefetch: warmDistributionCentersList,
    },
    {
        id: 'catalogos.delivery_route_zones.list',
        ttlMs: 45000,
        match: createMatcher(/^\/delivery_route_zones$/),
        prefetch: warmDeliveryRouteZonesList,
    },
    {
        id: 'catalogos.locations.list',
        ttlMs: 45000,
        match: createMatcher(/^\/locations\/(supply|expense)$/),
        prefetch: warmLocationsList,
    },
    {
        id: 'catalogos.services.list',
        ttlMs: 45000,
        match: createMatcher(/^\/services$/),
        prefetch: warmServicesList,
    },
    {
        id: 'catalogos.driver_expenses.list',
        ttlMs: 45000,
        match: createMatcher(/^\/driver_expenses\/(traffic|expenses)$/),
        prefetch: warmDriverExpensesList,
    },
    {
        id: 'catalogos.starmilk_routes.list',
        ttlMs: 45000,
        match: createMatcher(/^\/expense_routes\/(traffic|expenses)$/),
        prefetch: warmStarmilkRoutesList,
    },
    {
        id: 'catalogos.origins_destinations.list',
        ttlMs: 45000,
        match: createMatcher(/^\/origins_destinations$/),
        prefetch: warmOriginsDestinationsList,
    },
    {
        id: 'catalogos.folios.list',
        ttlMs: 45000,
        match: createMatcher(/^\/folios$/),
        prefetch: warmFoliosList,
    },
    {
        id: 'catalogos.tolls.list',
        ttlMs: 45000,
        match: createMatcher(/^\/tolls$/),
        prefetch: warmTollsList,
    },
    {
        id: 'catalogos.companies.list',
        ttlMs: 45000,
        match: createMatcher(/^\/companies\/(config|traffic)$/),
        prefetch: warmCompaniesList,
    },
    {
        id: 'catalogos.transport_means.list',
        ttlMs: 45000,
        match: createMatcher(/^\/transport_means$/),
        prefetch: warmTransportMeansList,
    },
    {
        id: 'catalogos.transport_figures.list',
        ttlMs: 45000,
        match: createMatcher(/^\/transport_figure$/),
        prefetch: warmTransportFiguresList,
    },
    {
        id: 'catalogos.work_shifts.list',
        ttlMs: 45000,
        match: createMatcher(/^\/work_shifts$/),
        prefetch: warmWorkShiftsList,
    },
    {
        id: 'catalogos.roles.list',
        ttlMs: 45000,
        match: createMatcher(/^\/settings\/role$/),
        prefetch: warmRolesList,
    },
    {
        id: 'catalogos.users.list',
        ttlMs: 45000,
        match: createMatcher(/^\/settings\/user$/),
        prefetch: warmUsersList,
    },
    {
        id: 'catalogos.branch_offices.list',
        ttlMs: 45000,
        match: createMatcher(/^\/branch_office$/),
        prefetch: warmBranchOfficesList,
    },
    {
        id: 'catalogos.banks.list',
        ttlMs: 45000,
        match: createMatcher(/^\/bank$/),
        prefetch: warmBanksList,
    },
    {
        id: 'catalogos.bank_transactions.list',
        ttlMs: 45000,
        match: createMatcher(/^\/bank_transaction$/),
        prefetch: warmBankTransactionsList,
    },
    {
        id: 'catalogos.bank_catalog.list',
        ttlMs: 45000,
        match: createMatcher(/^\/bank_catalog$/),
        prefetch: warmBankCatalogList,
    },
    {
        id: 'catalogos.inspection_formats.list',
        ttlMs: 45000,
        match: createMatcher(/^\/inspection_format$/),
        prefetch: warmInspectionFormatsList,
    },
    {
        id: 'catalogos.inspection_categorys.list',
        ttlMs: 45000,
        match: createMatcher(/^\/inspection_category$/),
        prefetch: warmInspectionCategorysList,
    },
    {
        id: 'catalogos.tours.list',
        ttlMs: 45000,
        match: createMatcher(/^\/tours$/),
        prefetch: warmToursList,
    },
    {
        id: 'catalogos.incidents.list',
        ttlMs: 45000,
        match: createMatcher(/^\/incident$/),
        prefetch: warmIncidentsList,
    },
    {
        id: 'catalogos.hr_categories.list',
        ttlMs: 45000,
        match: createMatcher(/^\/categories_hr$/),
        prefetch: warmHRCategoriesList,
    },
    {
        id: 'catalogos.associates.list',
        ttlMs: 45000,
        match: createMatcher(/^\/associates$/),
        prefetch: warmAssociatesList,
    },
    {
        id: 'catalogos.units.list',
        ttlMs: 30000,
        match: createMatcher(/^\/units\/catalogs$/),
        prefetch: warmUnitsList,
    },
    {
        id: 'catalogos.units.new',
        ttlMs: 30000,
        match: createMatcher(/^\/units\/catalogs\/new$/),
        prefetch: async ({ dispatch }) => warmUnitsSupportData({ dispatch }),
    },
    {
        id: 'catalogos.units.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/units\/catalogs\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => warmUnitsSupportData({
            dispatch,
            itemId: params.id,
        }),
    },
    {
        id: 'catalogos.client_branches.list',
        ttlMs: 300000,
        match: createMatcher(/^\/client_branch$/),
        prefetch: async ({ dispatch }) => {
            const items = await dispatch(clientBranchesActions.load({
                page: 1,
                limit: 50,
                params: {
                    fields: CLIENT_BRANCH_DETAIL_FIELDS,
                },
                force: true,
            }))

            return {
                items: Array.isArray(items) ? items : [],
                listLoaded: true,
            }
        },
    },
    {
        id: 'catalogos.client_branches.new',
        ttlMs: 30000,
        match: createMatcher(/^\/client_branch\/new$/),
        prefetch: async ({ dispatch }) => warmClientBranchesSupportData({ dispatch }),
    },
    {
        id: 'catalogos.client_branches.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/client_branch\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => warmClientBranchesSupportData({
            dispatch,
            itemId: params.id,
        }),
    },
    {
        id: 'catalogos.requests.list',
        ttlMs: 300000,
        match: createMatcher(/^\/request$/),
        prefetch: async ({ dispatch }) => {
            const items = await dispatch(requestsActions.load({
                page: 1,
                limit: 50,
                force: true,
            }))

            return {
                items: Array.isArray(items) ? items : [],
                listLoaded: true,
            }
        },
    },
    {
        id: 'catalogos.requests.new',
        ttlMs: 30000,
        match: createMatcher(/^\/request\/new$/),
        prefetch: async () => ({ supportLoaded: true }),
    },
    {
        id: 'catalogos.requests.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/request\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch, params }) => {
            const item = await dispatch(requestsActions.get(params.id))
            return { item }
        },
    },
    {
        id: 'catalogos.trailers.list',
        ttlMs: 300000,
        match: createMatcher(/^\/trailers\/catalogs$/),
        prefetch: warmTrailersList,
    },
    {
        id: 'catalogos.trailers.new',
        ttlMs: 30000,
        match: createMatcher(/^\/trailers\/catalogs\/new$/),
        prefetch: async ({ dispatch }) => {
            await Promise.all([
                dispatch(trailerGroupActions.load({ force: true })),
                dispatch(branchOfficeActions.load({ params: {} })),
                dispatch(trailerAxleTemplateActions.load()),
            ])
            return { warmed: true }
        },
    },
    {
        id: 'catalogos.trailers.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/trailers\/catalogs\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: async ({ dispatch }) => {
            await Promise.all([
                dispatch(trailerGroupActions.load({ force: true })),
                dispatch(branchOfficeActions.load({ params: {} })),
                dispatch(trailerAxleTemplateActions.load()),
            ])
            return { warmed: true }
        },
    },
    {
        id: 'catalogos.unitMeasures.list',
        ttlMs: 300000,
        match: createMatcher(/^\/unit_measures\/(?<scope>\w+)$/, (match) => ({ scope: match.groups.scope })),
        prefetch: warmUnitMeasuresList,
    },
    {
        id: 'catalogos.unitMeasures.new',
        ttlMs: 30000,
        match: createMatcher(/^\/unit_measures\/(?<scope>\w+)\/new$/, (match) => ({ scope: match.groups.scope })),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
    {
        id: 'catalogos.unitMeasures.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/unit_measures\/(?<scope>\w+)\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
            scope: match.groups.scope,
        })),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
    {
        id: 'catalogos.suppliers.list',
        ttlMs: 300000,
        match: createMatcher(/^\/suppliers\/(?<scope>\w+)$/, (match) => ({ scope: match.groups.scope })),
        prefetch: warmSuppliersList,
    },
    {
        id: 'catalogos.suppliers.new',
        ttlMs: 30000,
        match: createMatcher(/^\/suppliers\/(?<scope>\w+)\/new$/, (match) => ({ scope: match.groups.scope })),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
    {
        id: 'catalogos.suppliers.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/suppliers\/(?<scope>\w+)\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
            scope: match.groups.scope,
        })),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
    {
        id: 'catalogos.customCatalogs.list',
        ttlMs: 300000,
        match: createMatcher(/^\/custom_catalogs\/(?<scope>\w+)$/, (match) => ({ scope: match.groups.scope })),
        prefetch: warmCustomCatalogsList,
    },
    {
        id: 'catalogos.customCatalogs.new',
        ttlMs: 30000,
        match: createMatcher(/^\/custom_catalogs\/(?<scope>\w+)\/new$/, (match) => ({ scope: match.groups.scope })),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
    {
        id: 'catalogos.customCatalogs.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/custom_catalogs\/(?<scope>\w+)\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
            scope: match.groups.scope,
        })),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
    {
        id: 'catalogos.trailerAxleTemplates.list',
        ttlMs: 300000,
        match: createMatcher(/^\/trailer_axle_templates$/),
        prefetch: warmTrailerAxleTemplatesList,
    },
    {
        id: 'catalogos.trailerAxleTemplates.new',
        ttlMs: 30000,
        match: createMatcher(/^\/trailer_axle_templates\/new$/),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
    {
        id: 'catalogos.trailerAxleTemplates.detail',
        ttlMs: 30000,
        match: createMatcher(/^\/trailer_axle_templates\/(?<id>\d+)$/, (match) => ({
            id: parseInt(match.groups.id, 10),
        })),
        prefetch: () => Promise.resolve({ warmed: true }),
    },
]
